import {useState} from 'react';
import {Link} from 'react-router-dom'

import { useTranslation } from "react-i18next";
import "../../translations/i18n";

import './filterspanel.style.css'



const FiltersPanel = ({filters, appliedFilters, onChangeFilters, onRemoveAllFilters}) => {
  
    const showMax=10;
    const [showAllActivities, setShowAllActivities] = useState(false)
    
    const handleShowMore = e => {
      setShowAllActivities(!showAllActivities);
    }
  
    const {t} = useTranslation();

    return (
      <>
      <div className="filters-panel-nav">
      <Link className="returnlink" to={`/`}>{t('filterpanel.return')}</Link>
      <a className="remove-all-filters" onClick={onRemoveAllFilters}>{t('filterpanel.clear')} ✕</a>
      </div>
      {
        filters.map((f,index)=>{
          return (
            <div className="filters-panel-element" key={index}>
              <h3>{f.Name}</h3>
              <div className={`input_filters ${showAllActivities?'show-all':''}`}>
                {
                  f.Values.map(({Id,Name,Count},index)=>{
                    //const state=appliedFilters[f.Key]?.includes(Id.toString());
                    const state=appliedFilters[f.Key]?.includes(Id);
                    const isDisplayed=(( index < showMax)) || (f.Key!='actcat');
                    const isHidden=isDisplayed?'':'filter-hidden';
                    return (
                      <span key={index} className={`input-filter ${isHidden}`}>
                        <label>
                        <input className="checkbox" type="checkbox" data-category={`${f.Key}`} data-id={f.Key!=='q'?parseInt(Id):Id} data-id-old={`${Id.toString()}`}
                          checked={!!state}
                          onChange={onChangeFilters}
                        />
                        <span className="input-filter-name">{Name}</span><span className="input-filter-count">{Count}</span>
                      </label>
                    </span>
                    )})}
              </div>
              { f.Key == 'actcat' && 
              <a className="show-more" onClick={handleShowMore}>
                {showAllActivities?t('filterpanel.show_less'):t('filterpanel.show_more')}
              </a>
              }
            </div>
          );})}
      </>
    )
  }

export default FiltersPanel